import { Header } from 'components/Header/Header';
import styles from './Layout.module.css';
import { SubHeader } from 'components/SubHeader/SubHeader';
import { Menu } from 'components/Menu/Menu';
import { ReactNode } from 'react';
import { Footer } from 'components/Footer/Footer';
import { usePlayerLayout } from 'lib/playerLayout';
import { ModernDesktopShell } from './ModernDesktopShell';

export interface DesktopLayoutProps {
  children?: ReactNode;
  hideSubheader?: boolean;
  hideMenu?: boolean;
  hideFooter?: boolean;
  whiteBg?: boolean;
}
export const Layout = ({
  children = <></>,
  hideSubheader = false,
  hideMenu = false,
  hideFooter = false,
  whiteBg = false,
}: DesktopLayoutProps) => {
  const layout = usePlayerLayout();
  if (layout === 'modern') {
    return <ModernDesktopShell>{children}</ModernDesktopShell>;
  }
  return (
    <>
      <Header />
      <div className={styles.pageWrapper}>
        <div className={styles.contentWrapper}>
          {!hideSubheader && <SubHeader />}
          {!hideMenu && (
            <div className={styles.menuWrapper}>
              <Menu />
            </div>
          )}
          <div
            className={styles.pageContent}
            data-has-subheader={!hideSubheader}
            data-white-bg={whiteBg}
          >
            {children}
          </div>
        </div>
        {!hideFooter && <Footer />}
      </div>
    </>
  );
};
